var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconRealEstateActionBuildingHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 9.75V1.5a.75.75 0 0 0-1.013-.7l-8.25 4.27a.75.75 0 0 0-.487.7v3.98m7.5-4.5h2.25m-3.75 3h3.75m-15 4.5H3m-2.25 3H4.5M8.25 4.156V.751m0 22.499v-12a1.5 1.5 0 0 0-1.5-1.5h-4.5a1.5 1.5 0 0 0-1.5 1.5v12h9m7.5 0-5.114-5.335a3.025 3.025 0 0 1-.567-3.492h0a3.026 3.026 0 0 1 4.846-.786l.835.835.835-.835a3.026 3.026 0 0 1 4.846.786h0a3.025 3.025 0 0 1-.567 3.492Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconRealEstateActionBuildingHeart);
export default __webpack_public_path__ + "static/media/streamline-icon-real-estate-action-building-heart.f295fb58.svg";
export { ForwardRef as ReactComponent };